import { createAction, props } from '@ngrx/store';
import { VleLead } from 'src/models/module-wise/leads/lead';

export const paginateLeads = createAction(
  '[ LEADS ] Paginating'
);

export const loadVleLeads = createAction(
  '[ LEAD VLE ] Load Lead',
  props<{ payload: VleLead[], totalDocuments: number }>()
);

export const removeVleLeads = createAction(
  '[ LEAD VLE ] Delete Lead',
  props<{ payload: string[] }>()
);

export const removeAllVleLeads = createAction(
  '[ LEAD VLE]  Remove All Lead'
);
